import { render, staticRenderFns } from "./ItemNoteDialog.vue?vue&type=template&id=052efdaa&scoped=true"
import script from "./ItemNoteDialog.vue?vue&type=script&lang=js"
export * from "./ItemNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052efdaa",
  null
  
)

export default component.exports